// extracted by mini-css-extract-plugin
export var compact = "pMWH4";
export var full = "V2DTI";
export var mailListShimmerContainer = "oU7Uf";
export var paddingFirstMessage = "zUVP4";
export var paddingMessage = "ZFFAK";
export var shimmerRow = "YdqPY";